import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';

import PostpaidDetalization from './containers/PostpaidDetalization';
import PrepaidDetalization from './containers/PrepaidDetalization';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const Detalization = ({ isPostpaid, isRestrictedAccess, ...props }) => {
  if (isRestrictedAccess) {
    return <Redirect to="/" />;
  }

  return isPostpaid
    ? <PostpaidDetalization {...props} />
    : <PrepaidDetalization {...props} />;
};

function mapStateToProps(state) {
  return {
    isPostpaid: state.application.isPostpaid,
    isConvergent: state.application.isConvergent,
    isPorted: state.application.isPorted,
  };
}

Detalization.propTypes = {
  isPostpaid: PropTypes.bool,
  isConvergent: PropTypes.bool,
  isRestrictedAccess: PropTypes.bool,
};

export default compose(
  connect(mapStateToProps),
  withViewAnalytics,
)(Detalization);
